import GenericCta from './generic-cta';
import AutomobileAsset from '../asset/automobile-asset';

export default class AutomobileCta extends GenericCta<AutomobileAsset> {}
